module.exports = __webpack_public_path__ + "b2b624dcd619a1f814096f5794d7e223.png";